import $ from 'jquery';
import _ from 'underscore';

export default class {
	constructor(options) {
		const defaults = {
			el: '.js-roaming-price',
			dom: {
				tiles: '.js-roaming-price-tiles',
				template: '.js-roaming-price-template'
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		return this;
	}

	getDom() {
		const self = this;
		self.$tiles = self.$el.find(self.options.dom.tiles);
		self.$template = self.$el.find(self.options.dom.template);
		this.template = _.template(this.$template.html().trim());
		return self;
	}

	set(data) {
		this.$tiles.html(this.template(data));
		return this;
	}

	render() {
		const self = this;
		if (self.$el.length) {
			self.getDom();
		}
		return self;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/roaming/price/price.js